import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import AccountLoged from "@/shared/mixins/AccountLoged";
import ParametrosComissoesController from "@/shared/controllers/parametroComissoes/parametroComissoes";

const name = 'GerenciamentoComissoes'
export default {
  name,

  components: {
    gCard,
    gForm
   }, 

  props: { },
  mixins:[AccountLoged],

  mounted () { 
    if(!this.hasClaim('Gerenciamento-Comissões')) {
      this.$router.push('/sem-acesso')
    }
    this.getAll();
  },

  updated () { },

  data () {
    return { 
        ParametrosComissao: [],
        minima: null,
        maxima: null
    }
  },

  methods: {

    getAll(){

        ParametrosComissoesController.getParametrosComissoes().requisicao
        .then((res => {
         this.minima = res.data.data[0].comissaoMinima;
         this.maxima = res.data.data[0].comissaoMaxima;
        }))
      },

      editarComissao(){
        let dataParaOBack = {
            comissaoMinima: this.minima,
            comissaoMaxima: this.maxima,
          }
          this.axios({
            method: 'post',
            url: process.env.VUE_APP_WEB_API + `ParametrosComissao/EditarParametrosComissao`,
            data: dataParaOBack
          })
            .then(() => {
                this.getAll();
            })
            .catch(() => {
            });
      },
      cancelarEdicao(){
        this.getAll();
      }
   },

  computed: { }, 

};